"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookAppointmentRequestStruct = exports.BookAppoinmentRequestOrderStruct = exports.BookAppoinmentRequestOrderProductStruct = void 0;
const superstruct_1 = require("superstruct");
const types_1 = require("../types");
const formData_1 = require("../types/formData");
exports.BookAppoinmentRequestOrderProductStruct = (0, superstruct_1.type)({
    productId: (0, superstruct_1.string)(),
    quantity: (0, superstruct_1.number)(),
});
exports.BookAppoinmentRequestOrderStruct = (0, superstruct_1.type)({
    inventoryId: (0, superstruct_1.string)(),
    products: (0, superstruct_1.array)(exports.BookAppoinmentRequestOrderProductStruct),
});
exports.BookAppointmentRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    scheduleId: (0, superstruct_1.string)(),
    startTime: (0, superstruct_1.string)(),
    endTime: (0, superstruct_1.string)(),
    serviceId: (0, superstruct_1.string)(),
    pushToken: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    order: (0, superstruct_1.optional)(exports.BookAppoinmentRequestOrderStruct),
    formData: (0, superstruct_1.optional)(formData_1.FormDataStruct),
    contactData: types_1.ContactDataStruct,
    preferredLanguage: (0, superstruct_1.optional)(types_1.LocaleLongStruct),
    createdFrom: (0, superstruct_1.enums)(['visitor', 'counter', 'kiosk']),
    kioskCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    counterId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
//# sourceMappingURL=BookAppointmentRequest.js.map